import { ArrowBack, ChevronRight } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Grid,
  Input,
  InputLabel,
  styled,
  TextField,
} from "@mui/material";
import React from "react";

const gradeList = [
  { grade: "prep" },
  { grade: "Grade 1" },
  { grade: "Grade 2" },
  { grade: "Grade 3" },
  { grade: "Grade 4" },
  { grade: "Grade 5" },
  { grade: "Grade 6" },
  { grade: "Grade 7" },
  { grade: "Grade 8" },
  { grade: "Grade 9" },
  { grade: "Grade 10" },
];

const GradeBox = styled("div")(({ theme }) => ({
  padding: "8px 15px",
  borderBottom: "1px solid #eaeaea",
  borderRadius: "8px",
  background: "#fff",
  transition: "0.3s",
  display: "block",
  cursor: "pointer",
  marginBottom: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "&:hover": {
    color: "#888",
    background: "#1976d2",
    // borderBottom: "1px solid transparent",
  },
}));

const GradeDiv = styled("div")(({ theme }) => ({
  borderRadius: "10px",
  padding: "20px",
  border: "1px solid #bdbdbd"
}))

const SelectGrade = ({
  handleChangeGrade,
  customerDetails,
  step,
  setStep,
  handleChange,
}) => {


  return (
    <Card>
      <Box p={4}>
        <Box mb={3} textAlign="center">
          <h2>Grade</h2>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputLabel sx={{ marginBottom: "20px" }}>Select Grade</InputLabel>
            <GradeDiv>
              {gradeList.map((grade, index) => (
                <GradeBox
                  style={{
                    background: grade.grade === customerDetails.grade ? "#1976d2" : "#fff",
                    color: grade.grade === customerDetails.grade ? "#fff" : "#888",
                  }}
                  onClick={() => handleChangeGrade(grade.grade)}
                >
                  {grade.grade}
                  <ChevronRight fontSize="small" />
                </GradeBox>
              ))}
            </GradeDiv>
            {/* <Autocomplete
              sx={{ background: "#fff" }}
              disablePortal
              id="grade"
              options={gradeList}
              onChange={(event, newValue) => {
                handleChangeGrade(newValue);
              }}
              inputValue={customerDetails.grade}
              // sx={{ width: 300 }}
              getOptionLabel={(option) => option.grade}
              renderInput={(params) => (
                <TextField
                  {...params}
                  onChange={handleChange}
                  value={customerDetails.grade}
                  variant="outlined"
                  name="grade"
                  // label="GRADE"
                />
              )}
            /> */}
          </Grid>
          <Grid item xs={12}>
            <Box textAlign={"left"} mt={3}>
              <Button
                size="large"
                variant="contained"
                color="secondary"
                onClick={() => setStep(step - 1)}
                style={{ marginRight: "10px" }}
              >
                <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} /> Back
              </Button>
              {/* <Button
                variant="contained"
                color="primary"
                onClick={() => setStep(step + 1)}
              >
                Next
              </Button> */}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default SelectGrade;
